import T from 'i18n-react'
import TextsEs from './es.json'

export function initTranslator() {
    T.setTexts(TextsEs)
}

export function translate(key: string, options?: any) {
    return T.translate(key, options)
}
